module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/app.component.css
// module id = ./src/app/core/components/app.component.css
// module chunks = main